import React, { useEffect, useState, useCallback } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table, Dropdown, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize';
import axiosInstance from "../services/axiosInterceptor";
import { useLoading } from '../contexts/LoadingContext';

const API = process.env.REACT_APP_API;

export default function AllClassGrade() {
  const { setLoading } = useLoading();
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead');
      if (skin === 'dark') {
        for (const thead of theads) { thead.classList.remove('table-secondary'); thead.classList.add('table-primary'); }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) { thead.classList.remove('table-primary'); thead.classList.add('table-secondary'); }
      }
    }
  };
  switchSkin(skin);
  useEffect(() => { switchSkin(skin); }, [skin]);

  const authHeader = { headers: { authorization: `Bearer ${getToken()}` } };

  const [yearList, setYearList]         = useState([]);
  const [yearId, setYearId]             = useState(() => localStorage.getItem('yearId') || null);
  const [selectedYear, setSelectedYear] = useState('');
  const [classList, setClassList]       = useState([]);
  const [activeClass, setActiveClass]   = useState('1');
  const [roomList, setRoomList]         = useState([]);

  useEffect(() => {
    axiosInstance.get(`${API}/getStudyYear`, authHeader)
    .then(res => {
      const list = res.data;
      setYearList(list);
      let id = localStorage.getItem('yearId');
      if (!id && list.length > 0) { id = list[0].year_id; localStorage.setItem('yearId', id); }
      setYearId(id);
      const found = list.find(y => String(y.year_id) === String(id));
      if (found) setSelectedYear(`ปีการศึกษา ${found.year_year}`);
    }).catch(() => {});

    axiosInstance.get(`${API}/getClassList`, authHeader)
    .then(res => {
      setClassList(res.data || []);
      if (res.data?.length > 0) setActiveClass(String(res.data[0].c_id));
    }).catch(() => {});
  }, []);

  const loadRooms = useCallback(() => {
    if (!yearId || !activeClass) return;
    setLoading(true);
    axiosInstance.get(`${API}/getRoomListByClassId/${activeClass}/${yearId}`, authHeader)
    .then(res => setRoomList(res.data || []))
    .catch(() => setRoomList([]))
    .finally(() => setLoading(false));
  }, [yearId, activeClass, setLoading]);

  useEffect(() => { loadRooms(); }, [loadRooms]);

  const handleSelectYear = (id) => {
    const found = yearList.find(y => y.year_id === id);
    if (found) {
      setYearId(id);
      setSelectedYear(`ปีการศึกษา ${found.year_year}`);
      localStorage.setItem('yearId', id);
    }
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">วัดผลและประเมินผล</Link></li>
              <li className="breadcrumb-item active">เกรดรวมในชั้นเรียน</li>
            </ol>
            <h4 className="main-title mb-0">เกรดรวมในชั้นเรียน</h4>
          </div>
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-year">
                {selectedYear || 'เลือกปีการศึกษา'}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {yearList.map(y => (
                  <Dropdown.Item key={y.year_id} onClick={() => handleSelectYear(y.year_id)}>
                    ปีการศึกษา {y.year_year}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row className="g-3">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header>
                <Nav variant="tabs" activeKey={activeClass} onSelect={k => setActiveClass(k)}>
                  {classList.map(c => (
                    <Nav.Item key={c.c_id}>
                      <Nav.Link eventKey={String(c.c_id)}>{c.c_class}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Card.Header>
              <Card.Body className="p-3">
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th className="text-center" style={{ width: 60 }}>ที่</th>
                      <th className="text-center" style={{ width: 120 }}>ชั้นเรียน</th>
                      <th>ครูประจำชั้น</th>
                      <th className="text-center" style={{ width: 150 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {roomList.length > 0 ? roomList.map((r, i) => (
                      <tr key={r.r_id}>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-center">ม.{r.tb_class_c_id}/{r.r_no} {r.p_code ? `(${r.p_code})` : ''}</td>
                        <td>{r.t_name || '-'}</td>
                        <td className="text-center">
                          <Link to={`/assessment/class-grade/${r.r_id}/${yearId}`}>
                            <i className="ri-table-line"></i> ดูเกรดรวม
                          </Link>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={4} className="text-center text-muted py-4">ไม่พบห้องเรียนในชั้นนี้</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
